import { useParams } from 'react-router';
import { z } from 'zod';

const getDefaultsValuesByZodSchema = <Schema extends z.AnyZodObject>(schema: Schema) => {
    return Object.fromEntries(
        Object.entries(schema.shape).map(([key, value]) => {
            if (value instanceof z.ZodDefault) return [key, value._def.defaultValue()]
            return [key, undefined]
        }),
    )
}

export const useParsedRouteParams = <T>(zodSchema: z.ZodType<T, any, any>): { isValid: boolean } & T => {
    const params = useParams();
    const defaultValue = getDefaultsValuesByZodSchema(zodSchema) as z.infer<typeof zodSchema>;

    const result = zodSchema.safeParse(params);

    if (!result.success)
        return { ...defaultValue, isValid: result.success };

    const data = result.data as z.infer<typeof zodSchema>;

    return { isValid: result.success, ...data };
};